The source of the component.

Currently, two codes are defined:

- `Custom` indicates that the question was authored by the hirer.
- `Library` indicates that the question was sourced from SEEK's question library.
